import styled from 'styled-components';
import { ITheme } from '../../styles/theme';

interface ITab {
  active: boolean;
  theme: ITheme;
}

export const Tab = styled.div<ITab>`
  cursor: pointer;
  height: 39px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  border-radius: 8px 8px 0 0;
  font-weight: 500;
  position: relative;
  font-size: 17px;

  ${({ theme, active }: ITab) => `
    background: ${active ? '#F9F9F9' : 'transparent'};
    border-top: 1px solid ${active ? theme.colors.neutral.primary[30] : 'transparent'};
    border-left: 1px solid ${active ? theme.colors.neutral.primary[30] : 'transparent'};
    border-right: 1px solid ${active ? theme.colors.neutral.primary[30] : 'transparent'};
    bottom: ${active ? '-1px' : 0};
    color: ${theme.colors.neutral.secondary[100]};
  `};
`;

export const Tabs = styled.div`
  display: flex;
`;

export const Container = styled.div`
  margin-left: 56px;
  margin-top: 12px;
`;

interface IChildren {
  theme: ITheme;
}

export const Children = styled.div`
  margin: 0 24px 24px 0;
  padding: 0 20px;
  border-radius: 0 6px 6px 6px;

  ${({ theme }: IChildren) => `
    background: #F9F9F9;
    border: 1px solid ${theme.colors.neutral.primary[30]};
  `};
`;
